<label class="form-label" [innerHTML]="label"></label>
<div
	[ngClass]="{ 'fw-medium': value, 'fst-italic fw-normal text-secondary': !value }"
	[innerHTML]="value || 'empty'"
></div>
